import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import ViewData from "./ViewData";
import UserInfo from "@utils/UserInfo";
import { CenterListContainer } from "./CenterList.styled";

import "./CenterList.scss";
/**
 * Center List,
 * Path - /analyticalNotes
 * @see See [Center Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2920611841/Centre+products+list)
 * @component
 */
const CenterList = (props) => {
  const { t, companyId } = props;
  const countryId = UserInfo.countryId();
  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  return (
    <CenterListContainer className="center-list">
      <ViewData
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        countryId={countryId}
        companyId={companyId}
      />
    </CenterListContainer>
  );
};

CenterList.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(CenterList);
